import FooterWrapper from './FooterWrapper';

export default FooterWrapper;
